module.exports = __webpack_public_path__ + "img/bitmap.aadb8baa.png";